import React, { Fragment } from 'react';
import Layout from './Layout';

function App() {
    return (
        <Fragment>
           <Layout/>
        </Fragment >
    );
}

export default App;
